// extracted by mini-css-extract-plugin
export default {"base":"base-YIF6Q","item":"item-Dfxob","cycle":"cycle-RlRmV","whiteIcon":"whiteIcon-JxyPO","text":"text-RyQ93"};